module.exports = __webpack_public_path__ + "static/img/NSW-shield-logo.48b58b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-shield-logo.svg
// module id = MlcH
// module chunks = 0